<script lang="ts">
  import { EmptyLabelDefault } from '$shared/constants/global';
  import { transformListKey } from '$shared/helpers/ListKeyFormat';

  interface Props {
    data: IDataList;
    onevent?: (payload: any) => void;
  }

  let { data, onevent }: Props = $props();

  // Helper to check if value is a DataListAsComponent
  function isDataListAsComponent(value: any): value is DataListAsComponent {
    return value && typeof value === 'object' && 'component' in value;
  }
</script>

<div class="simple-list-comp">
  {#each Object.entries(data || {}) as [key, value]}
    <div class="detail-value">
      <div data-cy={`${key}-k`} class="key">
        {transformListKey(key)}
      </div>
      {#if isDataListAsComponent(value)}
        <div class="component-value">
          <value.component {...value.props} {onevent} />
        </div>
      {:else}
        <div data-cy={`${key}-v`} class="value">{value || EmptyLabelDefault}</div>
      {/if}
    </div>
  {/each}
</div>

<style>
  .detail-value {
    display: flex;
    line-height: 25px;
    align-items: flex-start;
  }
  .detail-value .key {
    width: 180px;
    flex-shrink: 0;
    margin-right: 16px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }
  .detail-value .value,
  .detail-value .component-value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--grey-dark);
  }
  .component-value {
    margin-top: 2px;
  }
</style>
